export enum EndpointsInvoices {
  ElectricityInvoices = "/invoices/",
  ExportInvoices = "/invoices/export/",
}

export enum EndpointsFilter {
  FieldParams = "/filter/params",
}